<template>
  <el-scrollbar style="width:100%;height: 100%;overflow:auto;">
    <el-form label-width="150px" style="margin-top: 10px">
      <el-row>
        <el-col :span="11">
          <el-form-item label="年度月份：" required>
            <el-select v-model="year" placeholder="年度" style="width:50%;padding-right:5px; " @change="getEmployeeKpiList">
              <el-option v-for="year in yearList" :key="year.value" :label="year.label" :value="year.value"></el-option>
            </el-select>
            <el-select v-model="month" placeholder="月份" style="width:50%;padding-left: 5px" >
              <el-option v-for="item in 12" :key="item" :label="item" :value="item"></el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="11">
          <el-form-item label="公司：" required>
            <el-select v-model="company" placeholder="请选择公司" @change="getTeamList" >
              <el-option v-for="item in companyList" :key="item.value" :label="item.label" :value="item.value">
              </el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="11">
          <el-form-item label="团队：" required>
            <el-select v-model="team" placeholder="请选择团队" @change="getEmployeeList" >
              <el-option v-for="item in teamList" :key="item.value" :label="item.label" :value="item.value"></el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="11">
          <el-form-item label="员工：" required>
            <el-select v-model="employee_id" placeholder="请选择员工" >
              <el-option v-for="item in employeeList" :key="item.value" :label="item.label" :value="item.value"></el-option>
            </el-select>
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
    <div style="margin-left: 10px;margin-bottom: 10px">员工月度KPI设定：&nbsp;&nbsp;&nbsp;&nbsp;
      <span v-if="!year" style="color: #fc0202">(请选择年度后获取KPI数据)</span>
    </div>
    <div style="display: flex;margin-left: 10px;margin-right: 10px;background-color: #cccccc;text-align: center;line-height: 30px">
      <div style="width: 80px;">序号</div>
      <div style="flex: 1">KPI名称</div>
      <div style="width: 150px">KPI数值(套/个)</div>
    </div>
    <div style="min-height: 200px;margin-top: 10px;margin-bottom: 10px">
      <div v-for="(item,index) in employeeKpiList"
           style="display: flex;margin: 10px 10px 0 10px;text-align: center;line-height: 30px">
        <div style="width: 80px;">{{index + 1}}</div>
        <div style="flex: 1">{{item.kpi_name}}</div>
        <div style="width: 150px">
          <el-input-number style="padding: 0 5px 0 5px;" v-model="item.kpi_value" min="0" :controls="false" ></el-input-number>
        </div>
      </div>
    </div>
    <div style="text-align: center;">
      <el-button type="primary" style="width: 100px" @click="editEmployeeKpi">保存</el-button>
    </div>



  </el-scrollbar>

</template>

<script>
export default {
  name: "EditEmployeeKpi",
  inject: ['$fn'],
  props: {
    parentData: {
      type: Object,
      default: () => {
        return {}
      }
    },
  },

  data(){
    return{
      company:'',
      team:'',
      employee_id:'',
      year:'',
      month:'',
      companyList:[],
      teamList:[],
      employeeList:[],
      yearList:[],
      employeeKpiList:[],
    }
  },
  async created() {
    await this.initData();
  },
  mounted() {

  },
  methods: {
    async initData(){
      this.year = this.parentData.year;
      this.month = this.parentData.month;
      this.employee_id = this.parentData.employee_id;
      await this.getEmployeeInfo();
      await this.getCompanyList();
      await this.getYearList();
      await this.getTeamList('first');
      await this.getEmployeeList('first');
      await this.getEmployeeKpiList();
    },
    editEmployeeKpi(){
      if(!this.year){
        this.$message.error("请选择年度");
      }
      if(!this.month){
        this.$message.error("请选择月份");
      }
      if(!this.company){
        this.$message.error("请选择公司");
      }
      if(!this.team){
        this.$message.error("请选择团队");
      }
      if(!this.employee_id){
        this.$message.error("请选择员工");
      }
      if(!this.employeeKpiList || this.employeeKpiList.length === 0){
        this.$message.error("KPI项目数据为空");
      }
      let params = {year:this.year,
        month:this.month,
        company:this.company,
        team:this.team,
        employee_id:this.employee_id,
        employeeKpiList:this.employeeKpiList}
      this.$http('crmEmployeeService.editEmployeeKpi',params).then(() => {
        this.$fn.closeWindow();
        this.$fn.search();
        this.$message.success("提交成功");
      });
    },
    async getEmployeeInfo(){
      let params = {employee_id:this.parentData.employee_id}
      let dbEmployee = await this.$http('crmTeamService.getEmployeeInfo', params);
      if (dbEmployee) {
        this.company = dbEmployee.parent_id;
        this.team = dbEmployee.id;
      }

    },
    async getCompanyList(){
      this.companyList = await this.$http('crmTeamService.getCompanyList');
    },
    async getYearList(){
      this.yearList = await this.$http('sysDsService.getYears(5,2)')
    },
    //获取员工的KPI项目
    async getEmployeeKpiList() {
      if (!this.year) {
        this.$message.error("请选择年度后获取KPI数据");
      }
      let params = {year: this.year, month: this.month, employee_id: this.employee_id}
      this.employeeKpiList = await this.$http('crmEmployeeService.getEmployeeKpiInfo', params);
    },
    //根据公司选择团队数据
    async getTeamList(value){
      let params = {company:this.company}
      this.teamList = await this.$http('crmTeamService.getTeamByCompany',params);
      if (value !== 'first') {
        if (this.team) {
          this.team = ""
        }
        if (this.employee_id) {
          this.employee_id = ""
        }
      }
    },
    //根据团队获取员工
    async getEmployeeList(value){
      let params = {team:this.team}
      this.employeeList = await this.$http('crmTeamService.getEmployeeByTeam',params);
      if (value !== 'first') {
        if (this.employee_id) {
          this.employee_id = ""
        }
      }
    },
  }
}
</script>

<style scoped>

</style>